import { render, staticRenderFns } from "./MicrophoneStatus.vue?vue&type=template&id=24bc97d2&scoped=true&"
import script from "./MicrophoneStatus.vue?vue&type=script&lang=js&"
export * from "./MicrophoneStatus.vue?vue&type=script&lang=js&"
import style0 from "./MicrophoneStatus.vue?vue&type=style&index=0&id=24bc97d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc97d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
})
